import { connect } from "react-redux";
import Output from "../Output";

export const mapStateToProps = state => {
  const hashtags = state.output || [];
  return { hashtags };
};

const mapDispatchToProps = dispatch => {
  return {
    onDelete: hashtag => {
      dispatch({ type: "DESELECT_ONE_ROW", hashtag });
    }
  };
};

// Container Component
const CurrentOutput = connect(mapStateToProps, mapDispatchToProps)(Output);

export default CurrentOutput;



// WEBPACK FOOTER //
// ./src/containers/CurrentOutput.js